import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import { ForgotRestaurant } from '../Api/AuthRestaurant';
import '../Css/forgout.css';

const ModalForgotPasswordRestaurant = ({ show, onHide }) => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        const data = { email: email };
        ForgotRestaurant(data).then(function (response) {
            if (response.data.title === "success") {
                toast.success(response.data.message);
                onHide();
            }
        }).catch(function (error) {
            console.log(error.response);
            if (error) {
                toast.error(error.response.data.message);
            }
        }).finally(function () {
            setEmail("");
            setLoading(false);
        });
    }

    return (
        <Modal
            show={show} onHide={onHide}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <form onSubmit={handleSubmit}>
                <Modal.Body>
                    <div className='forgotView'>

                        <h3 className="text-center">Entrer votre adresse e-mail</h3>

                        <input type="email" className="form-control" id="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="Adresse e-mail..." />
                        <div className='d-flex justify-content-between'>
                            <button type="button" className='btn btn_close' onClick={onHide}>Fermer</button>
                            {loading ? <Button className='btn btn_send' disabled>
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    variant="info"
                                    className="spiner"
                                />
                                Loading...
                            </Button> : <button type="submit" className='btn btn_send'>Envoyé</button>}


                        </div>
                    </div>
                </Modal.Body>

            </form>
        </Modal>
    )
}

export default ModalForgotPasswordRestaurant